<template>
  <div style="width: 100%; height: 25vh; max-height: 320px" id="map"></div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GENERAL_STORE } from '@apps/order-form/src/store'

export default {
  name: 'MapComponent',
  data: () => ({
    myMap: null,
    multiRoute: null,
    singleDot: null,
  }),
  computed: {
    ...mapGetters(GENERAL_STORE, ['selectedCity', 'dotsCoordinates']),
  },
  watch: {
    dotsCoordinates(newVal) {
      if (newVal.length === 0 || (window.ymaps && !window.ymaps.multiRouter) || !this.myMap) {
        return
      }

      if (newVal.length > 1) this.setMultiRoute()
      else this.setSingleDot()
    },
    selectedCity() {
      if (this.myMap) {
        this.myMap.setCenter([this.selectedCity.lat, this.selectedCity.lng])
      }
    },
  },
  methods: {
    setMultiRoute() {
      if (this.multiRoute) {
        this.myMap.geoObjects.remove(this.multiRoute)
        this.multiRoute = null
      }

      if (this.singleDot) {
        this.myMap.geoObjects.remove(this.singleDot)
        this.singleDot = null
      }

      this.multiRoute = new window.ymaps.multiRouter.MultiRoute(
        {
          referencePoints: this.dotsCoordinates,
          params: {
            results: 2,
          },
        },
        {
          boundsAutoApply: true,
        }
      )

      this.myMap.geoObjects.add(this.multiRoute)
    },

    setSingleDot() {
      if (this.multiRoute) {
        this.myMap.geoObjects.remove(this.multiRoute)
        this.multiRoute = null
      }

      if (this.singleDot) {
        this.myMap.geoObjects.remove(this.singleDot)
        this.singleDot = null
      }

      this.singleDot = new window.ymaps.Placemark(
        this.dotsCoordinates[0],
        {
          balloonContent: 'Укажите другие адреса, чтобы построить маршрут.',
        },
        {
          preset: 'islands#circleIcon',
          iconColor: '#3caa3c',
        }
      )

      this.myMap.setCenter(this.dotsCoordinates[0])
      this.myMap.geoObjects.add(this.singleDot)
    },
  },
  mounted() {
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

    const initMap = () => {
      window.ymaps.ready(() => {
        this.myMap = new window.ymaps.Map('map', {
          center: [this.selectedCity.lat, this.selectedCity.lng],
          controls: ['zoomControl'],
          zoom: 10,
        })

        if (!this.dotsCoordinates.length) return
        if (this.dotsCoordinates.length > 1) this.setMultiRoute()
        else this.setSingleDot()
      })
    }

    if (!isMobileDevice) {
      window.checkMap = setInterval(() => {
        if (window.ymaps) {
          initMap()
          clearInterval(window.checkMap)
        }
      }, 300)
    }
  },
}
</script>

<style></style>
